import { AgentIconWithFallback } from 'ai-components-ui-library/components/icons/AgentIconWithFallback';
import { View } from 'foundations-components/components/View';
import { Image } from 'foundations-components/transitional/components/Image';
import { MAX_VISIBLE_ICONS } from 'marketplace-ui-common/workflow-templates/constants/icon-group';
import { WorkflowTemplateIconGroup } from 'marketplace-ui-common/workflow-templates/WorkflowTemplateIconGroup';
import { getWorkflowIconsFromProductFeatures } from '../../utils/getWorkflowIconsFromProductFeatures';
import { useLazyImage } from './LazyImageProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export function ListingIcon({
  listing,
  iconSize
}) {
  const lazyImage = useLazyImage();
  const product = listing.products[0];
  const isWorkflowTemplate = (product === null || product === void 0 ? void 0 : product.productType) === 'WORKFLOW_TEMPLATE';
  const isPartner = (product === null || product === void 0 ? void 0 : product.productType) === 'SOLUTIONS_PARTNER_PROFILE';
  if (isWorkflowTemplate) {
    return /*#__PURE__*/_jsx(WorkflowTemplateIconGroup, {
      actionIcons: getWorkflowIconsFromProductFeatures(product.productFeatures),
      maxIcons: MAX_VISIBLE_ICONS
    });
  }
  if (listing.iconUrl) {
    if (isPartner) {
      return /*#__PURE__*/_jsx(Image, {
        alt: listing.listingName,
        blockSize: `${iconSize}px`,
        loading: lazyImage,
        marginBlockEnd: "0",
        maxInlineSize: "120px",
        minInlineSize: `${iconSize}px`,
        objectFit: "contain",
        responsive: false,
        shape: "rounded",
        src: listing.iconUrl
      });
    }
    return /*#__PURE__*/_jsx(Image, {
      alt: listing.listingName,
      blockSize: `${iconSize}px`,
      inlineSize: `${iconSize}px`,
      loading: lazyImage,
      marginBlockEnd: "0",
      objectFit: "contain",
      responsive: false,
      src: listing.iconUrl
    });
  }
  return (
    /*#__PURE__*/
    // add a border because otherwise it clashes with the gray background and looks ugly
    _jsx(View, {
      borderColor: "border-accent-magenta-default",
      borderWidth: "100",
      borderRadius: "300",
      borderStyle: "solid",
      overflow: "hidden",
      children: /*#__PURE__*/_jsx(AgentIconWithFallback, {
        loading: lazyImage,
        marginBlockEnd: "0",
        name: listing.listingName
        // accomodate the width of the border (if it exists)
        ,
        size: iconSize - 2
      })
    })
  );
}